import React, {
  useContext,
  useEffect,
  useState,
} from "react";
import { API_URL } from "../components/api";
import "bootstrap/dist/css/bootstrap.css";
import "./requestsHistory.css";
import Axios from "axios";
import AuthContext from "../context/AuthContext";
import { Modal } from "react-bootstrap";

function ReportFrame({ embedded, onHide, children }) {
  if (embedded) {
    return children;
  }

  return (
    <Modal
      show
      onHide={onHide}
      size="xl"
      centered
      className="account-drawer-report-modal request-report-modal"
      backdropClassName="request-report-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>Drawer Transfer</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="request-history-content drawer-request-report">
          {children}
        </div>
      </Modal.Body>
    </Modal>
  );
}

function RequestHistory({
  requestId = null,
  accountDetail = false,
  onClose = null,
}) {
  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(
    localStorage.getItem("authTokens")
  );

  const [history, setHistory] = useState([]);
  const [detail, setDetail] = useState(null);
  const [activeHolder, setActiveHolder] = useState(null);
  const [detailLoading, setDetailLoading] =
    useState(false);
  const [detailError, setDetailError] =
    useState("");

  const embeddedDetail = requestId !== null;

  useEffect(() => {
    if (embeddedDetail) {
      return undefined;
    }

    let isMounted = true;

    const getHistory = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/requests/`,
          {
            headers: {
              Authorization:
                `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
              action: "History",
            },
          }
        );

        if (
          response.status === 200
          && isMounted
        ) {
          setHistory(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getHistory();

    return () => {
      isMounted = false;
    };
  }, [
    authTokens.access,
    embeddedDetail,
    user.username,
  ]);

  const formatDate = (value) => {
    if (!value) {
      return "-";
    }

    return new Date(value).toLocaleString(
      "en-GB",
      {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      }
    );
  };

  const formatAmount = (value) => (
    Number(value || 0).toLocaleString(
      "en-US",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    )
  );

  const canView = (item) => (
    String(item.type || "").toLowerCase()
      === "accounting"
  );

  const handleView = async (
    selectedRequestId
  ) => {
    setDetail(null);
    setActiveHolder(null);
    setDetailError("");
    setDetailLoading(true);

    try {
      const response = await Axios.get(
        (
          accountDetail
            ? `${API_URL}/accounting/account/catalog/transfer-requests/`
            : `${API_URL}/inventory/requests/`
        ),
        {
          headers: {
            Authorization:
              `Bearer ${authTokens.access}`,
          },
          params: accountDetail
            ? {
              detail_request_id:
                selectedRequestId,
            }
            : {
              action: "Detail",
              request_id:
                selectedRequestId,
            },
        }
      );

      if (response.status === 200) {
        setDetail(response.data);
      }
    } catch (error) {
      setDetailError(
        error.response?.data?.error
        || "The drawer details could not be loaded."
      );
    } finally {
      setDetailLoading(false);
    }
  };

  useEffect(() => {
    if (embeddedDetail) {
      handleView(requestId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestId, embeddedDetail]);

  const handlePrint = () => {
    const printable = document.getElementById(
      "drawer-request-print"
    );

    if (!printable) {
      return;
    }

    const printWindow = window.open(
      "",
      "_blank",
      "width=1000,height=700"
    );

    if (!printWindow) {
      setDetailError(
        "The print window was blocked."
      );
      return;
    }

    printWindow.document.write(`
      <!doctype html>
      <html>
        <head>
          <title>Drawer Transfer</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 24px;
              color: #000;
            }

            h2 {
              text-align: center;
              margin-bottom: 20px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 18px;
            }

            th,
            td {
              border: 1px solid #000;
              padding: 7px;
              text-align: left;
              vertical-align: top;
              font-size: 12px;
            }

            th {
              font-weight: 700;
            }
          </style>
        </head>
        <body>
          ${printable.innerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();

    window.setTimeout(() => {
      printWindow.print();
    }, 250);
  };

  return (
    <div className="request-history-content drawer-request-report">
      <div
        className="request-history-scroll"
        style={{
          overflowX: "auto",
          display: embeddedDetail
            ? "none"
            : undefined,
        }}
      >
        <table className="request-history-table">
          <thead>
            <tr>
              <th>Receiver</th>
              <th>Description</th>
              <th>Type</th>
              <th>Response</th>
              <th>Submitted</th>
              <th>Resolved</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {history.map((item) => (
              <tr key={item.request_id}>
                <td>{item.receiver}</td>
                <td>{item.description}</td>
                <td>{item.type}</td>
                <td>{item.response}</td>
                <td>{formatDate(item.date)}</td>
                <td>
                  {formatDate(item.resolved_at)}
                </td>
                <td>
                  {canView(item) && (
                    <button
                      type="button"
                      className="drawer-report-button"
                      onClick={() => (
                        handleView(item.request_id)
                      )}
                    >
                      View
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {detailLoading && (
        <div className="mt-3">
          Loading...
        </div>
      )}

      {detailError && (
        <div className="drawer-report-error">
          {detailError}
        </div>
      )}

      {detail && (
        <ReportFrame
          embedded={embeddedDetail}
          onHide={() => setDetail(null)}
        >
        <div className="drawer-report-content">
          <div className="drawer-report-actions">
            <button
              type="button"
              className="drawer-report-button"
              onClick={handlePrint}
            >
              Print
            </button>

            <button
              type="button"
              className="drawer-report-button drawer-report-button-secondary"
              onClick={() => {
                setDetail(null);

                if (onClose) {
                  onClose();
                }
              }}
            >
              Close
            </button>
          </div>

          <div
            id="drawer-request-print"
            className="drawer-request-print"
          >
            <h2>Drawer Transfer</h2>

            <table>
              <tbody>
                <tr>
                  <th>Request</th>
                  <td>
                    {detail.request.request_id}
                  </td>
                  <th>Transaction</th>
                  <td>
                    {
                      detail.transaction
                        .transaction_id
                    }
                  </td>
                </tr>

                <tr>
                  <th>From</th>
                  <td>
                    {detail.request.initiator}
                  </td>
                  <th>Receiver</th>
                  <td>
                    {detail.request.receiver}
                  </td>
                </tr>

                <tr>
                  <th>Submitted</th>
                  <td>
                    {formatDate(
                      detail.request.submitted_at
                    )}
                  </td>
                  <th>Resolved</th>
                  <td>
                    {formatDate(
                      detail.request.resolved_at
                    )}
                  </td>
                </tr>

                <tr>
                  <th>Status</th>
                  <td colSpan="3">
                    {detail.request.response}
                  </td>
                </tr>

                <tr>
                  <th>Description</th>
                  <td colSpan="3">
                    {
                      detail.transaction
                        .description
                    }
                  </td>
                </tr>
              </tbody>
            </table>

            {(detail.holders && detail.holders.length > 0) && (
              <div className="holder-tabs">
                <button
                  type="button"
                  className={"holder-tab" + (activeHolder === null ? " holder-tab-active" : "")}
                  onClick={() => setActiveHolder(null)}
                >
                  All
                </button>
                {detail.holders.map((h) => (
                  <button
                    key={h.id}
                    type="button"
                    className={"holder-tab" + (activeHolder === h.id ? " holder-tab-active" : "")}
                    onClick={() => setActiveHolder(h.id)}
                  >
                    {h.name}
                  </button>
                ))}
              </div>
            )}

            <table>
              <thead>
                <tr>
                  <th>Currency</th>
                  <th>A Account</th>
                  <th>S Fee</th>
                  <th>P Product</th>
                  <th>R Reseller</th>
                  <th>C Contract</th>
                  <th>V VAT</th>
                  <th>D Deposit</th>
                  <th>E Expenses</th>
                  <th>L Loan</th>
                  <th>Payments</th>
                  <th>U Unclassified</th>
                  <th>OPC Online Payment Cash Out</th>
                  <th>OPF Online Payment Fees</th>
                  <th>OP Online Payments</th>
                  <th>OPT Online Payment Total</th>
                  <th>Total</th>
                  <th>G Total</th>
                </tr>
              </thead>

              <tbody>
                {["USD", "LBP"].map((currency) => {
                  const key = currency.toLowerCase();

                  return (
                    <tr key={currency}>
                      <th>{currency}</th>

                      {[
                        "A",
                        "S",
                        "P",
                        "R",
                        "C",
                        "V",
                        "D",
                        "E",
                        "L",
                        "PAY",
                        "U",
                        "OP",
                        "OPF",
                        "OPP",
                        "OPT",
                      ].map((code) => (
                        <td key={code}>
                          {formatAmount(
                            (activeHolder === null
                              ? detail.categories
                              : (detail.holder_categories || {})[activeHolder])
                              ?.[code]
                              ?.[key]
                          )}
                        </td>
                      ))}

                      <td>
                        {formatAmount(
                          (activeHolder === null
                            ? detail.summary
                            : (detail.holder_summary || {})[activeHolder])
                            ?.[`total_${key}`]
                        )}
                      </td>

                      <td>
                        {formatAmount(
                          (activeHolder === null
                            ? detail.summary
                            : (detail.holder_summary || {})[activeHolder])
                            ?.[
                              `grand_total_${key}`
                            ]
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {(activeHolder === null
              || activeHolder === (detail.holders || []).find((h) => h.name === "OSS")?.id) && (
              <div>
                Pocket money exchange included in G Total:{" "}
                {formatAmount(detail.exchange?.usd)} USD
                {" / "}
                {formatAmount(detail.exchange?.lbp)} LBP
              </div>
            )}

            <table>
              <thead>
                <tr>
                  <th>Type</th>
                  <th>ID</th>
                  <th>Client</th>
                  <th>Description</th>
                  <th>Category</th>
                  <th>Items / Proof</th>
                  <th>Paid USD</th>
                  <th>Paid LBP</th>
                  <th>Returned USD</th>
                  <th>Returned LBP</th>
                  <th>Net USD</th>
                  <th>Net LBP</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>
                {detail.records
                  .filter((record) => activeHolder === null || record.holder_id === activeHolder)
                  .map((record) => (
                  <tr
                    key={
                      `${record.record_type}-`
                      + record.record_id
                    }
                  >
                    <td>{record.record_type}</td>
                    <td>{record.record_id}</td>
                    <td>{record.party}</td>
                    <td>{record.description}</td>
                    <td>{record.category}</td>
                    <td>
                      <div>{record.proof}</div>

                      {(record.items || []).map(
                        (item, index) => (
                          <div
                            key={
                              `${record.record_id}-`
                              + index
                            }
                          >
                            {item}
                          </div>
                        )
                      )}
                    </td>
                    <td>
                      {formatAmount(
                        record.paid_usd
                      )}
                    </td>
                    <td>
                      {formatAmount(
                        record.paid_lbp
                      )}
                    </td>
                    <td>
                      {formatAmount(
                        record.returned_usd
                      )}
                    </td>
                    <td>
                      {formatAmount(
                        record.returned_lbp
                      )}
                    </td>
                    <td>
                      {formatAmount(
                        record.net_usd
                      )}
                    </td>
                    <td>
                      {formatAmount(
                        record.net_lbp
                      )}
                    </td>
                    <td>
                      {formatDate(record.date)}
                    </td>
                  </tr>
                ))}

                {detail.records.length === 0 && (
                  <tr>
                    <td colSpan="13">
                      No records
                    </td>
                  </tr>
                )}
              </tbody>
            </table>


          </div>
        </div>
        </ReportFrame>
      )}
    </div>
  );
}

export default RequestHistory;
